import {AgentService} from '../service/agent.service';
import {RequestService} from '../service/request.service';
import {SessionService} from '../service/session.service';
import {UserService} from '../service/user.service';
export function AgentServiceFactory(
  request: RequestService,
  _user: UserService,
  sessionService: SessionService) {
  return new AgentService(request, _user, sessionService);
};



// WEBPACK FOOTER //
// ./src/app/shared/factory/agentservice.factory.ts